import React from 'react';

const AdminQuestionsHeader = ({ loading, total, onBack }) => (
  <div className="mb-8">
    <div className="flex items-center justify-between">
      <div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
          Manage Assessment Questions
        </h1>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          {loading ? 'Loading...' : `Total: ${total || 0} questions`}
        </p>
      </div>
      <button
        onClick={onBack}
        className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-50 dark:hover:bg-gray-700"
      >
        ← Back to Admin
      </button>
    </div>
  </div>
);

export default AdminQuestionsHeader;


